import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/holding-period-return-calculator',
  component: () => import('../../routes/HoldingPeriodReturn.svelte'),
  card: {
    id: 'holding-period-return-calculator',
    title: 'Holding Period Return (HPR)',
    description: 'Calculate your total investment return including capital gains and income over any holding period.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/holding-period-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Holding Period Return (HPR) Calculator – Total Investment Return',
    description: 'Free Holding Period Return (HPR) calculator to calculate your total investment return including capital gains and income dividends over any holding period. See annualized returns and year-by-year breakdown.',
  },
};

export default meta;
